import { useField } from 'formik';

export const useFormFieldMeta = <T,>(name: string) => {
  const [, meta, helpers] = useField<T>(name);
  return { hasError: meta.touched && !!meta.error, ...meta, helpers };
};
